import { Link } from 'gatsby'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Image from '../../function/Image'
import parse from 'html-react-parser'

const ClientHero = ({ clientHero }) => {
    const { image, logo, title, backgroundImage, iconLink } = clientHero || {}
    return (
        <section>
            <div className="relative pb-10 lg:pb-40 overflow-x-clip overflow-y-hidden">
                <div className="h-14 lg:h-[120px]"></div>

                <div className="container lg:grid z-10 lg:grid-cols-12 relative lg:gap-x-5">
                    <div className="whitespace-pre-wrap lg:pt-7 lg:col-span-4 flex flex-col items-center sm:items-start mb-10 xl:mb-0 text-center xl:text-left">
                        {logo?.localFile ? (
                            <GatsbyImage
                                objectFit="contain"
                                width={200}
                                image={getImage(
                                    logo?.localFile?.childImageSharp
                                )}
                                alt={logo?.altText || ''}
                                className="!w-[200px]"
                            />
                        ):(
                            <img
                                width={200}
                                src={
                                    logo?.sourceUrl
                                }
                                alt={logo?.altText || ''}
                                className="!w-[200px] object-contain !mt-0"
                            />
                        )}
                        {title && (
                            <h1 className="mt-5 h3 sm:text-left sm:max-w-[380px]">
                                {title}
                            </h1>
                        )}
                        {/* <Button styles={'primary'}>DOWNLOAD FULL CASE STUDY</Button> */}
                    </div>
                    <div className="lg:col-span-6 lg:col-start-6 flex flex-col relative max-w-screen-sm lg:max-w-none">
                        <span className="pl-2 flex justify-start items-center w-full h-8 bg-ghost_white inset-0 rounded-t-md">
                            <span className="w-2 h-2 rounded-full bg-slate-300"></span>
                            <span className="w-2 h-2 rounded-full bg-slate-300 mx-1"></span>
                            <span className="w-2 h-2 rounded-full bg-slate-300 "></span>
                        </span>
                        <div className="w-full relative h-full aspect-[816/481]">
                            {image?.localFile ? (
                                <GatsbyImage
                                    objectFit="cover"
                                    image={getImage(
                                        image?.localFile?.childImageSharp
                                    )}
                                    alt={image?.altText || ''}
                                    className="!absolute inset-0 !w-full h-full"
                                />
                            ):(
                                <img
                                    src={
                                        image?.sourceUrl
                                    }
                                    alt={image?.altText || ''}
                                    className="!absolute inset-0 !w-full h-full object-cover !mt-0"
                                />
                            )}
                        </div>
                    </div>
                </div>
                {backgroundImage && (
                    <div className="absolute right-0 top-0 translate-x-1/4 w-[70vw] lg:-translate-y-[7%] xl:-translate-y-[15%] hidden sm:block">
                        <Image
                            objectFit="contain"
                            {...backgroundImage}
                            className="!w-full"
                        />
                    </div>
                )}
            </div>

            <div className="container pt-10">
                {iconLink?.link?.title && (
                    <Link
                        to={iconLink?.link?.url}
                        target={iconLink?.link?.target}
                        className="flex flex-col sm:flex-row sm:justify-center gap-x-3 hover:text-vivid_raspberry gap-y-3 items-center"
                    >
                        <div className="aspect-square w-10">
                            {iconLink?.icon?.localFile ? (
                                <GatsbyImage
                                    objectFit="contain"
                                    image={getImage(
                                        iconLink?.icon?.localFile
                                            ?.childImageSharp
                                    )}
                                    alt={iconLink?.icon?.altText}
                                    className={'!w-full h-full'}
                                />
                            ):(
                                <img
                                    src={
                                        iconLink?.icon?.sourceUrl
                                    }
                                    alt={iconLink?.icon?.altText}
                                    className={'!w-full h-full object-contain !mt-0'}
                                />
                            )}
                        </div>
                        <span className="h4 inline-block font-['FoundersGrotesk-Bold']">
                            {parse(iconLink?.link?.title)}
                        </span>
                    </Link>
                )}
            </div>
        </section>
    )
}

export default ClientHero
